import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['textVersion']

  connect() {
    // Apply stored preference on load
    const stored = window.UserPreference?.get('default_asset_version')
    if (stored === 'text' && this.hasTextVersionTarget) {
      this.textVersionTarget.classList.remove('hidden')
    }
  }

  switchVersion(e) {
    const { version } = e.detail
    this.textVersionTarget.classList.toggle('hidden', version !== 'text')
    window.UserPreference?.set('default_asset_version', version)
  }
}
